import React, { useState } from 'react';
import logo from "../assets/HerGrowthCoLogoLite.png";
import { Menu, X } from 'lucide-react';

function NavLite() {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  return (
    <nav className="font-inter mx-auto h-auto w-full max-w-screen-2xl md:relative md:top-0">
      <div className="flex flex-col md:flex-row items-center justify-between px-6 py-6 md:px-10 md:py-4 xl:px-20 relative">

        {/* Logo on the Left */}
        <div className="flex-shrink-0">
          <a href="/">
            <img
              src={logo}
              alt="Her Growth Co Logo"
              width="180"
              height="auto"
              className="mb-4 md:mb-0"
            />
          </a>
        </div>

        {/* Desktop Navigation and Contact Button */}
        <div className="hidden md:flex md:items-center md:space-x-8">

          {/* Navigation Links with Dropdowns */}
          <div className="flex flex-row space-x-6 font-semibold text-black uppercase">

            {/* Services Dropdown */}
            <div
              className="relative inline-block"
              onMouseEnter={() => setOpenDropdown('services')}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <span className="cursor-default inline-block text-white">Services</span>
              {openDropdown === 'services' && (
                <div className="absolute bg-white shadow-lg mt-0 py-2 z-50 w-56">
                <a href="/authoritylaunchpad" className="block px-2 py-2 hover:font-azeri">The Authority Launchpad Package</a>
                <a href="/strategicgrowthaccelerator" className="block px-2 py-2 hover:font-azeri">The Strategic Growth Accelerator Package</a>
                <a href="/authorityamplifier" className="block px-2 py-2 hover:font-azeri">The Authority Amplifier Package</a>
                <a href="/services" className="block px-2 py-2 hover:font-azeri">Other Services</a>
                  {/* <a href="/webdesign" className="block px-2 py-2 hover:font-azeri">Website Design</a>
                  <a href="/seopage" className="block px-2 py-2 hover:font-azeri">SEO Strategies</a>
                  <a href="/services" className="block px-2 py-2 hover:font-azeri">All Services and Packages</a>
                  <a href="/wireframekits" className="block px-2 py-2 hover:font-azeri">Website Mockup & Wireframe Kits</a>
                  <a href="/websiterefresh" className="block px-2 py-2 hover:font-azeri">Website Refresh</a>
                  <a href="/accessibilityaudits" className="block px-2 py-2 hover:font-azeri">Accessibility Audits</a>  */}
                </div>
              )}
            </div>

            {/* About Dropdown */}
            <div
              className="relative inline-block"
              onMouseEnter={() => setOpenDropdown('about')}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <span className="cursor-default inline-block text-white">About</span>
              {openDropdown === 'about' && (
                <div className="absolute bg-white shadow-lg mt-0 py-2 z-50 w-48">
                  <a href="/about" className="block px-2 py-2 hover:font-azeri">Meet the Team</a>
                  <a href="/testimonials" className="block px-2 py-2 hover:font-azeri">Testimonials</a>
                  <a href="/ourdifference" className="block px-2 py-2 hover:font-azeri">Our Difference</a>
                  <a href="/careers" className="block px-2 py-2 hover:font-azeri">Careers</a>
                </div>
              )}
            </div>

            {/* Resources Dropdown */}
            <div
              className="relative inline-block"
              onMouseEnter={() => setOpenDropdown('resources')}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <span className="cursor-default inline-block text-white">Resources</span>
              {openDropdown === 'resources' && (
                <div className="absolute bg-white shadow-lg mt-0 py-2 z-50 w-48">
                  <a href="/casestudies" className="block px-2 py-2 hover:font-azeri">Case Studies</a>
                  <a href="/blog" className="block px-2 py-2 hover:font-azeri">Blog</a>
                  <a href="/allplaybooks" className="block px-2 py-2 hover:font-azeri">All Playbooks</a>
                  <a href="/playbook" className="block px-2 py-2 hover:font-azeri">Paid Playbooks</a>
                  <a href="/toolsweuse" className="block px-2 py-2 hover:font-azeri">Tools We Use</a>
                </div>
              )}
            </div>
          </div>

          {/* Contact Button */}
          <a
            className="rounded-full bg-[#CFF098] px-12 py-2 text-black border-[1px] border-black uppercase hover:opacity-60"
            href="/contact"
          >
            Contact
          </a>
        </div>

        {/* Hamburger Menu on Right for Mobile */}
        <button
          className="absolute right-6 top-6 md:hidden text-white"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={30} /> : <Menu size={30} />}
        </button>

        {/* Mobile Menu */}
        <div
          className={`${
            isOpen ? 'flex' : 'hidden'
          } flex-col items-center space-y-6 md:hidden font-bold text-white bg-black p-5`}
        >
          <a href="/" className="uppercase hover:underline">Home</a>
          <a href="/services" className="uppercase hover:underline">About Us</a>
          <a href="/elitevisible" className="uppercase hover:underline">Elite Visible</a>
          <a href="/LocalSEO" className="uppercase hover:underline">Local SEO</a>
          <a
            className="rounded-full bg-[#CFF098] hover:underline px-12 py-2 text-black border-[1px] border-black uppercase hover:opacity-60"
            href="/contact"
          >
            Contact
          </a>
        </div>
      </div>
    </nav>
  );
}

export default NavLite;
